import { render, staticRenderFns } from "./ConsensiViewComponent.vue?vue&type=template&id=cbcec762"
import script from "./ConsensiViewComponent.vue?vue&type=script&lang=js"
export * from "./ConsensiViewComponent.vue?vue&type=script&lang=js"
import style0 from "./ConsensiViewComponent.vue?vue&type=style&index=0&id=cbcec762&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports